const TextBox = ({ name, value, placeholder = '',  unit = '', onChange = null, requiredMessage = null}) => (
  <div className={unit? "input-group":"rel"}>
    <input 
      className="form-control" 
      id={name} 
      name={name} 
      type="text" 
      value={value} 
      placeholder={placeholder} 
      onChange={onChange} 
      required 
      data-val="true" 
      data-val-required={requiredMessage} 
    />
    {unit && <span className="input-group-text">{unit}</span>}
    <span className="text-danger field-validation-valid" data-valmsg-for={name} data-valmsg-replace="true"></span>
  </div>
);

export default TextBox;
